import { useMemo, useState, useCallback } from 'react'
import styled, { css, keyframes } from 'styled-components'
import { FullScreenLoader, Heading } from '@staccx/bento'
import Container from '../../../components/Container'
import LostCard from '../components/LostCard'
import { TranslatedText } from '@staccx/i18n'
import { useCarContext } from '../../../context/CarProvider'
import { useDriverContext } from '../../../context/DriverProvider'
import { useChosenCompany, useFeatureToggles, useUser, useUserContext } from '../../../context/UserProvider'
import { useNotifications } from '../hooks/useNotifications'
import { createTextArray } from '../../../api/sanity'
import { useQuery } from 'react-query'
import { newsFromSanity } from '../../../api/api'
import { useI18nContext } from '../../../context/I18nProvider'
import { useNavigate } from 'react-router-dom'
import Dialog from '../../../components/modal/Dialog'
import { Link } from 'react-router-dom'
import customToast from '../../carConfiguration/components/toast/customToast'
import { fetchSalesPerson } from '../../../api/api'
import { useBudgetSelections, usePendingSignings } from '../../../context/SigningProvider'
import ContactForm from '../../../components/modal/ContactForm'
import ReportDamageForm from '../../../components/modal/ReportDamageForm'
import { ComparisonGraph } from '../../../components/ComparisonGraph'
import { InTransit } from '../../../components/InTransit'
import { bytelabConfig } from '../../../utils/bytelabConfig'
import { OrderProgress } from '../components/OrderProgress'
import { TaskList } from '../components/TaskList'
import { set } from 'lodash'
import Loader from '../../../components/Loader'
import { DealerView } from '../components/DealerView'

export function WasaLogo() {
  return (
    <svg width="190" height="44" viewBox="0 0 190 44" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M84.0683 41.9043V42.1221C83.5497 42.2855 82.9485 42.3669 82.402 42.3669C80.9543 42.3669 80.4899 42.0402 80.4899 40.1897C80.4899 37.6854 80.6264 37.4955 84.0683 37.4676V41.9043ZM87.8928 41.2783V33.7392C87.8928 31.0175 86.3358 29.5752 83.6315 29.5752C80.0527 29.5752 76.8561 30.6089 76.8561 33.2766C76.8561 34.4471 77.3755 35.1001 78.7414 35.1001C80.1074 35.1001 80.6539 34.2837 80.6539 33.1951C80.6539 32.1335 80.2713 31.8339 78.8779 31.6165V31.5346C78.8779 31.5346 80.326 31.4531 81.3365 31.4531C83.8772 31.4531 84.0683 31.5616 84.0683 34.2837V36.379H80.7628C77.6488 36.379 76.5015 37.3866 76.5015 40.2442C76.5015 43.1837 77.5666 44 80.1074 44C81.7466 44 83.3857 43.4555 84.2598 42.9114C84.6424 43.7278 85.5711 44 86.9095 44C87.7839 44 88.6025 43.8911 89.7773 43.7278V43.2382C88.1772 42.963 87.8928 42.5577 87.8928 41.2783Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M92.976 32.4873C92.976 31.3442 93.9322 30.8546 95.0791 30.8546C96.6912 30.8546 97.7292 31.4257 98.8222 33.8211H99.3137L99.1226 29.9019C99.1226 29.9019 97.0737 29.5752 95.6256 29.5752C91.938 29.5752 90.2441 30.9356 90.2441 33.8481C90.2441 39.5638 97.3195 37.8762 97.3195 40.9516C97.3195 42.0681 96.3908 42.7211 95.1884 42.7211C93.4679 42.7211 91.9922 42.0132 90.736 39.2915H90.2441L90.3259 43.3471C91.0635 43.5644 93.3035 44 94.9973 44C98.3575 44 100.161 42.3669 100.161 39.5912C100.161 34.1204 92.976 35.5082 92.976 32.4873Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M108.725 42.1212V37.4672C107.505 37.4856 106.667 37.5445 106.212 37.644C105.756 37.7439 105.465 37.9666 105.338 38.3113C105.21 38.6561 105.147 39.282 105.147 40.1893C105.147 40.8062 105.205 41.2689 105.324 41.5771C105.442 41.8862 105.634 42.0946 105.898 42.2035C106.162 42.312 106.549 42.3665 107.059 42.3665C107.66 42.3665 108.215 42.285 108.725 42.1212ZM112.701 42.312C112.801 42.5482 112.992 42.7341 113.274 42.87C113.557 43.0059 113.998 43.1288 114.6 43.2377V43.7273C113.288 43.9091 112.277 44 111.567 44C110.856 44 110.283 43.9181 109.846 43.7551C109.408 43.5914 109.098 43.3105 108.916 42.911C108.443 43.2012 107.824 43.4551 107.059 43.6729C106.294 43.8911 105.529 44 104.764 44C103.89 44 103.193 43.8862 102.674 43.6598C102.155 43.4325 101.772 43.0518 101.526 42.5159C101.281 41.9816 101.158 41.2234 101.158 40.2433C101.158 38.81 101.476 37.8074 102.114 37.2358C102.751 36.6639 103.853 36.3786 105.419 36.3786H108.725V34.2828C108.725 33.3207 108.671 32.6587 108.561 32.2952C108.452 31.9329 108.229 31.7011 107.892 31.6012C107.555 31.5018 106.922 31.4518 105.994 31.4518C105.447 31.4518 104.942 31.4608 104.477 31.4788C104.012 31.4973 103.698 31.5153 103.535 31.5333V31.6148C104.245 31.7241 104.718 31.8833 104.955 32.0913C105.192 32.3001 105.311 32.6677 105.311 33.1938C105.311 33.7748 105.155 34.2378 104.846 34.5817C104.536 34.9268 104.054 35.0992 103.398 35.0992C102.742 35.0992 102.264 34.9448 101.964 34.6361C101.663 34.3279 101.513 33.8747 101.513 33.2753C101.513 32.0233 102.15 31.0936 103.425 30.4852C104.7 29.8777 106.321 29.5735 108.288 29.5735C109.654 29.5735 110.706 29.9321 111.444 30.649C112.181 31.3658 112.55 32.3955 112.55 33.7383V41.2779C112.55 41.7315 112.6 42.0762 112.701 42.312Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M74.48 24.9465V25.446C75.2813 25.5725 75.8143 25.6953 76.0785 25.8132C76.3419 25.9316 76.4747 26.1174 76.4747 26.3717C76.4747 26.5714 76.3925 26.8883 76.2289 27.3239L72.3218 38.5927C71.9573 37.6494 71.3249 36.0204 70.4229 33.7069C69.5213 31.3934 68.7246 29.3206 68.0325 27.4873C67.9232 27.215 67.8686 26.9796 67.8686 26.7798C67.8686 26.4527 67.9915 26.2214 68.2376 26.0855C68.4833 25.9492 68.9341 25.7911 69.59 25.6089L70.1361 25.446V24.9465H61.0386V25.446C61.6574 25.5913 62.1041 25.7228 62.3774 25.8407C62.6502 25.9586 62.8688 26.1223 63.0328 26.3307C63.1967 26.5395 63.3607 26.8707 63.5247 27.3239L64.9452 31.2435L62.4045 38.5657C62.04 37.6224 61.4117 35.9938 60.5195 33.6795C59.627 31.3659 58.8347 29.3022 58.1423 27.4873C57.9788 27.0517 57.8966 26.7254 57.8966 26.5076C57.8966 26.2537 58.01 26.063 58.2381 25.9356C58.4657 25.8091 58.935 25.6458 59.6451 25.446V24.9465H50.9844V25.446C51.7125 25.6458 52.1863 25.7911 52.4054 25.8812C52.6236 25.9725 52.8241 26.1534 53.0061 26.4257C53.1882 26.698 53.4249 27.197 53.7162 27.9229L59.9705 43.7274H61.7154L65.6282 33.04L69.8608 43.7274H71.659C72.2454 42.1041 73.2813 39.2273 74.7668 35.0948C76.3419 30.7125 77.2846 28.1227 77.5948 27.3239C77.7588 26.8707 77.945 26.526 78.1549 26.2894C78.3637 26.054 78.7191 25.8632 79.2201 25.7178C79.721 25.5725 80.044 25.4828 80.1903 25.446V24.9465H74.48Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M186.916 39.2371V31.0176L189.976 30.3646V29.8405H186.916V25.9553H186.424L183.091 28.4592V40.625C183.091 43.1289 183.965 44.0001 186.315 44.0001C188.118 44.0001 189.125 43.2652 190 42.6663V42.2041H189.784C187.08 42.2041 186.916 42.0403 186.916 39.2371Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M176.573 27.7091C176.727 27.7549 176.996 27.777 177.379 27.777H178.308C178.69 27.777 178.959 27.7549 179.113 27.7091C179.268 27.664 179.368 27.5641 179.414 27.4098C179.459 27.2559 179.482 26.9877 179.482 26.607V25.6543C179.482 25.2727 179.459 25.0054 179.414 24.851C179.368 24.6971 179.268 24.5976 179.113 24.5518C178.959 24.5067 178.69 24.4834 178.308 24.4834H177.379C176.996 24.4834 176.727 24.5067 176.573 24.5518C176.418 24.5976 176.317 24.6971 176.273 24.851C176.227 25.0054 176.204 25.2727 176.204 25.6543V26.607C176.204 26.9877 176.227 27.2559 176.273 27.4098C176.317 27.5641 176.418 27.664 176.573 27.7091Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M168.704 41.9038C167.848 42.0672 166.918 42.149 165.917 42.149C165.316 42.149 164.86 41.9992 164.551 41.6999C164.241 41.4006 164.022 40.9016 163.895 40.2027C163.767 39.5043 163.704 38.4837 163.704 37.1404C163.704 35.2351 163.758 33.9147 163.868 33.1803C163.977 32.445 164.2 31.9783 164.538 31.7785C164.874 31.5787 165.489 31.4788 166.381 31.4788C167.42 31.4788 168.194 31.5247 168.704 31.6147V41.9038ZM180.548 42.7885C180.292 42.6706 180.128 42.5159 180.056 42.3255C179.983 42.1355 179.946 41.8129 179.946 41.3597V29.8457H174.073V30.3353C174.783 30.5175 175.27 30.667 175.534 30.7849C175.798 30.9032 175.962 31.0526 176.026 31.2344C176.089 31.4153 176.122 31.742 176.122 32.2137V41.3597C176.122 41.8317 176.089 42.158 176.026 42.3398C175.962 42.5208 175.798 42.6706 175.534 42.7885C175.331 42.8794 174.793 43.0055 174.308 43.0055C173.822 43.0059 173.319 42.8794 173.116 42.7885C172.851 42.6706 172.688 42.5208 172.625 42.3398C172.56 42.158 172.528 41.8317 172.528 41.3597V24.1296H166.655V24.6193C167.365 24.8015 167.852 24.9509 168.116 25.0688C168.38 25.1871 168.544 25.3366 168.608 25.5179C168.672 25.6993 168.704 26.0264 168.704 26.4976V30.4991C168.12 30.1904 167.483 29.9591 166.791 29.8048C166.099 29.6508 165.443 29.5734 164.824 29.5734C163.24 29.5919 161.974 30.1499 161.027 31.2475C160.079 32.3455 159.606 33.9925 159.606 36.1877C159.606 38.0386 159.765 39.5223 160.084 40.6379C160.402 41.7544 160.953 42.5936 161.737 43.1557C162.52 43.7187 163.613 43.9999 165.015 43.9999C166.071 43.9999 167.483 43.6278 169.25 42.8839V43.7273H181.995V43.2376C181.285 43.0563 180.802 42.9064 180.548 42.7885Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M144.867 29.8403H143.771C142.481 29.8403 142.385 29.9369 142.385 31.2212V32.3451C142.385 33.6298 142.481 33.7264 143.771 33.7264H144.867C146.156 33.7264 146.253 33.6298 146.253 32.3451V31.2212C146.253 29.9369 146.156 29.8403 144.867 29.8403Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M141.272 41.2939V29.8405H135.447C135.441 29.8405 135.438 29.8405 135.438 29.8405V30.3338C137.418 30.8472 137.473 31.0204 137.473 32.2912V41.2939C137.473 42.3002 137.434 42.5987 136.436 42.9348C136.268 42.9897 136.149 43.0306 136.009 43.0372C135.797 43.0462 135.619 42.9602 135.57 42.9336C135.099 42.6724 134.693 42.1733 133.976 41.1416L127.967 31.9964L131.517 27.3145C132.801 25.7903 133.305 25.6814 134.862 25.4366V24.9465H128.949V25.4366C130.342 25.627 130.861 25.7633 130.861 26.09C130.861 26.3348 130.506 26.716 129.987 27.3145L124.443 34.3644L128.867 41.278C129.304 41.8769 129.549 42.2572 129.549 42.5029C129.549 42.8836 129.003 42.9925 127.774 43.2374V43.7274H136.22V43.727H143.307V43.2202C141.353 42.7064 141.272 42.5373 141.272 41.2939Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M124.17 41.3594V27.3145C124.17 26.0351 124.224 25.9537 126.219 25.4366V24.9465H118.132V25.4366C120.099 25.9537 120.181 26.063 120.181 27.3145V41.3594C120.181 42.6388 120.126 42.7203 118.132 43.2374V43.7274H126.219V43.2374C124.251 42.7203 124.17 42.6118 124.17 41.3594Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M151.572 31.0842C151.317 31.2565 151.122 31.6606 150.985 32.2952C150.849 32.9306 150.771 33.9557 150.752 35.3714L154.632 35.2895V35.0177C154.632 33.7653 154.577 32.8442 154.468 32.2547C154.359 31.6647 154.181 31.2795 153.935 31.0981C153.689 30.9163 153.302 30.8258 152.774 30.8258C152.228 30.8258 151.827 30.9118 151.572 31.0842ZM150.916 40.1614C151.044 40.8333 151.362 41.3008 151.873 41.5636C152.383 41.8269 153.275 41.9583 154.55 41.9583H158.266V42.2305C157.592 42.8295 156.822 43.2745 155.957 43.5644C155.092 43.8546 154.086 44 152.938 44C151.627 44 150.516 43.7953 149.605 43.3871C148.694 42.9789 147.975 42.2305 147.447 41.1415C146.918 40.0529 146.654 38.5381 146.654 36.5959C146.654 33.9107 147.205 32.0692 148.307 31.0703C149.41 30.073 150.953 29.5735 152.938 29.5735C154.376 29.5735 155.493 29.7733 156.285 30.1724C157.078 30.5716 157.655 31.27 158.02 32.2686C158.384 33.2663 158.566 34.7094 158.566 36.5959H150.752C150.734 38.3019 150.789 39.4908 150.916 40.1614Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.6963 0V12.1629H31.683V43.7277H43.8913V0H15.6963Z"
        fill="currentColor"
      />
      <path fill-rule="evenodd" clip-rule="evenodd" d="M0 0V43.7277H28.195V31.5653H12.2083V0H0Z" fill="currentColor" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.6963 28.0903H28.1951V15.6379H15.6963V28.0903Z"
        fill="currentColor"
      />
    </svg>
  )
}

const Home = () => {
  const [showNewDriverModal, showNewDriverModalSet] = useState(false)
  const [showDamageReport, setShowDamageReport] = useState(false)
  const [selectedNewsArticle, selectedNewsArticleSet] = useState(null)
  const [newsPage, newsPageSet] = useState(0)
  const [showOrderCarDialog, showOrderCarDialogSet] = useState(false)

  const navigate = useNavigate()
  const company = useChosenCompany()
  const featureToggles = useFeatureToggles()

  const { updateCars, allCars } = useCarContext()
  const user = useUserContext()

  const { pendingSignings } = usePendingSignings(user?.user?.id)
  const { budgetSelections } = useBudgetSelections(user?.user?.id)
  const notifications = useNotifications(pendingSignings, budgetSelections, allCars)

  const { updateDrivers } = useDriverContext()
  const { data: news } = useQuery(['news'], () => newsFromSanity())
  const { language } = useI18nContext()
  const formattedNews = useMemo(() => {
    if (!news) return []
    return news.map((newsItem) => ({
      heading: newsItem?.newsHeading?.[language],
      id: newsItem?._id,
      ingress: createTextArray(newsItem?.newsIngress?.[language]),
      body: createTextArray(newsItem?.newsBody?.[language]),
      image: newsItem.newsImage,
      author: newsItem.newsAuthor,
      updatedAt: new Date(newsItem._updatedAt)
    }))
  }, [news, language])

  const { data: salesPerson } = useQuery(['salesperson', company?.id], () => fetchSalesPerson(company?.id), {
    enabled: !!company?.id
  })

  const onEditDriverFinish = () => {
    queryClient.invalidateQueries('cars').then(() => console.log('Updating cars'))
    queryClient.invalidateQueries('drivers').then(() => console.log('Updating drivers'))
    queryClient.invalidateQueries('contacts').then(() => console.log('Updating contacts'))
  }

  const confirmLostCardOrder = useCallback(() => {
    return customToast.success(<TranslatedText i18nKey="ORDER_COMPLETED" />)
  }, [])

  const faultOrder = useCallback(() => {
    return customToast.error(<TranslatedText i18nKey="ORDER_COMPLETED_ERROR" />)
  }, [])

  const co2Data = {
    title: 'Average CO2',
    data: 750,
    overAllAverage: 1100
  }

  const noxData = {
    title: 'Average NOX',
    data: 30,
    overAllAverage: 110
  }

  const signingTasks = [
    {
      date: '2021-09-01',
      type: 'Order',
      status: 'Awaiting signing',
      car: 'Volkswagen ID.5',
      driver: 'Fredrik Myhre',
      due: '2021-09-15'
    }
    /*     {
      date: '2021-09-01',
      type: 'Order',
      status: 'Awaiting external approval',
      car: 'Bmw i3',
      driver: "Johann Bugge",
      due: '2021-09-15'
    } */
  ]

  const findCurrentSeason = () => {
    const date = new Date()
    const month = date.getMonth()
    switch (month) {
      case 0:
      case 1:
      case 2:
      case 11:
      case 10:
      case 12:
      /*      return 'winter' */
      case 3:
      case 4:
      case 5:
      case 6:
      case 7:
      case 8:
        return 'summer'
      default:
        return 'summer'
    }
  }

  const currentSeason = findCurrentSeason()

  const [activeTask, setActiveTask] = useState(null)
  const [triggerModal, setTriggerModal] = useState(false)

  const handleTaskClick = (task) => {
    setActiveTask(task)
    setTriggerModal(true)
  }
  const userType = window.localStorage.getItem('userType') ?? 'customer'
  if (userType === 'dealer') {
    return (
      <div className="hide">
        <div className="px-16 pt-16 grayscale flex flex-col gap-2 w-full">
          <img src="/lffinans.png" alt="LF Logo" className=" w-40" />
          <p>Partner</p>
        </div>
        <DealerView />
      </div>
    )
  }
  return (
    <WrapperContainer>
      <Section>
        <TopWrapper>
          <div>
            <Heading level={3}>
              <p>Velkommen {user?.newUserData ? ',' : '!'}</p>
              {user?.newUserData?.profile?.name}
            </Heading>
          </div>
        </TopWrapper>
        <TasksList>
          <a target="_blank" href={`/Home/Profile`}>
            <ButtonCard text="Order car" image={currentSeason === 'winter' ? 'orderCar.png' : 'orderCarSummer.png'}>
              <ButtonCardIcon>
                <ArrowIcon />
              </ButtonCardIcon>
            </ButtonCard>
          </a>
          <Dialog
            open={showNewDriverModal}
            onOpenChange={showNewDriverModalSet}
            trigger={
              <ButtonCard
                onClick={() => showNewDriverModalSet(true)}
                text="New employee"
                image={currentSeason === 'winter' ? 'newEmployee.png' : 'newEmployeeSummer.png'}
              >
                <ButtonCardIcon>
                  <ArrowIcon />
                </ButtonCardIcon>
              </ButtonCard>
            }
          >
            <ContactForm
              close={showNewDriverModalSet}
              onFinish={async (setAsDriverOnCurrentCar) => {
                showNewDriverModalSet(false)
                updateDrivers()
                if (setAsDriverOnCurrentCar) {
                  updateCars()
                }
                ;() => onEditDriverFinish()
              }}
            />
          </Dialog>

          <LostCard onOrder={confirmLostCardOrder} onFaultOrder={faultOrder}>
            <ButtonCard
              text="Lost fuel card"
              image={currentSeason === 'winter' ? 'lostFuelCard.png' : 'lostFuelCardSummer.png'}
            >
              <ButtonCardIcon>
                <ArrowIcon />
              </ButtonCardIcon>
            </ButtonCard>
          </LostCard>
          <Dialog
            open={showDamageReport}
            onOpenChange={setShowDamageReport}
            trigger={
              <ButtonCard
                onClick={() => setShowDamageReport(true)}
                text="Report damage"
                image={currentSeason === 'winter' ? 'reportDamage.png' : 'reportDamageSummer.png'}
              >
                <ButtonCardIcon>
                  <ArrowIcon />
                </ButtonCardIcon>
              </ButtonCard>
            }
          >
            {' '}
            <ReportDamageForm
              close={setShowDamageReport}
              onFinish={() => {
                setShowDamageReport(false)
              }}
            />
          </Dialog>
        </TasksList>
      </Section>

      <MainPageContentLayout>
        <Section>
          <StyledContainer>
            <ComparisonGraph data={co2Data} />
            <ComparisonGraph data={noxData} />
          </StyledContainer>
        </Section>
        <Section>
          <Dialog open={triggerModal} onOpenChange={setTriggerModal}>
            <StyledDialog>
              <h3>Connecting to third party signing</h3>
              <Spinner />
            </StyledDialog>
          </Dialog>
          <OrderLayout>
            <h4>My tasks</h4>
            <OrderSectionWrapper>
              <TaskList handleTaskClick={handleTaskClick} taskType="Ongoing Changes" />
              <TaskList handleTaskClick={handleTaskClick} taskType="Signing" tasks={signingTasks} />
              <TaskList handleTaskClick={handleTaskClick} taskType="Termination" />
            </OrderSectionWrapper>
          </OrderLayout>
        </Section>
        <OrderLayout>
          <h4>Latest orders</h4>
          <OrderSectionWrapper>
            <OrderProgress />
          </OrderSectionWrapper>
        </OrderLayout>
      </MainPageContentLayout>
    </WrapperContainer>
  )
}

export default Home

const StyledDialog = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  align-items: center;
  justify-content: center;
`

const rotate360 = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`

const Spinner = styled.div`
  animation: ${rotate360} 1s linear infinite;
  transform: translateZ(0);

  border-top: 2px solid blue;
  border-right: 2px solid blue;
  border-bottom: 2px solid blue;
  border-left: 2px solid transparent;
  opacity: 0.75;
  background: transparent;
  width: 24px;
  height: 24px;
  border-radius: 100%;
`

const MainPageContentLayout = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3rem;
  width: 85%;
`

const OrderLayout = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`
const OrderSectionWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 2rem;
`
const WrapperContainer = styled.div`
  padding: 6rem 2rem;
  display: flex;
  flex-direction: column;
  gap: 3rem;
`
const StyledContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 2rem;
`

const NewsArticleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 2rem;
  * {
    margin: 0;
  }
`
const Url = styled.a`
  display: flex;
  align-items: center;

  gap: 15px;
  cursor: pointer;
  text-decoration: none;
  color: grey;
  transition: 100ms ease-in-out;
  font-weight: 500;
  :hover {
    gap: 30px;
  }
`
const NewsImage = styled.div`
  background-image: url('/bytelab.webp');
  background-size: cover;
  width: 100%;
  border-radius: 12px;
  min-height: 250px;
`
const NewsWrapper = styled.div`
  display: grid;
  grid-template-columns: auto 65%;
  gap: var(--spacing-large);
`
const TopWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-small);
  align-items: start;
  width: 100%;
`

const TasksList = styled.div`
  display: flex;
  flex-direction: row;
  gap: var(--spacing-medium);
  align-items: start;
  width: 100%;
  flex-wrap: wrap;
`
const Wrapper = styled.div`
  margin: 0 auto;
  padding: var(--spacing-medium);
  @media (min-width: 1200px) {
    padding: 0;
  }
`

const Center = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100%;
`
const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--spacing-largePlus);
  height: 100%;
  padding-top: var(--spacing-large);
  @media (min-width: 1200px) {
    grid-template-columns: 2fr 1fr;
  }
`

const Section = styled.div`
  display: grid;
  gap: 0.5rem;
`

const NewsPagination = styled.div`
  display: flex;
  justify-content: space-between;
  span {
    line-height: 2.5em;
    text-decoration: underline;
    color: var(--color-primary);
    cursor: pointer;
  }
`

const HelpDialogPadding = styled.div`
  padding: 0 0 10px 0;
  width: 100%;
`

const ClickHereForHelpText = styled.div`
  margin: 8px 0 0 0;
`
const HelpLink = styled(Link)`
  text-decoration: none;
`
const Content = styled.div`
  width: 100%;
  margin-top: var(--spacing-medium);
`

const ButtonCardIcon = styled.span`
  position: absolute;
  bottom: 10px;
  right: 5%;
  font-weight: 500;
  color: white;
`

const ButtonCard = styled.button`
  padding: 6rem 10rem;
  border: none;
  display: flex;
  align-items: end;
  justify-content: space-between;
  position: relative;
  border-radius: 12px;
  box-shadow: 0 5px 5px rgba(0, 0, 0, 0.1);
  transition: 0.3s ease-in-out;
  :hover {
    box-shadow: 0 5px 5px rgba(0, 0, 0, 0.2);
    cursor: pointer;
    :before {
      transition: 0.3s ease-in-out;
      background: linear-gradient(180deg, rgba(0, 0, 0, 0) 65%, rgba(0, 0, 0, 0.6) 100%);
    }
  }
  ${(p) => css`
    background-image: url('/${p.image}');
    background-size: cover;
  `}
  :before {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    transition: 0.3s ease-in-out;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0) 65%, rgba(0, 0, 0, 0.4) 100%);
    border-radius: 12px;
  }

  :after {
    ${(p) =>
      css`
        content: '${p.text}';
      `}
    position: absolute;
    bottom: 10px;
    left: 5%;
    font-size: 1.5rem;
    font-weight: 500;
    color: white;
  }
`

export function ArrowIcon({ color = 'red', currentColor = 'white' }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" height={20} width={20} viewBox="0 0 13 12">
      <path fill={currentColor} d="M.372 6.089a.902.902 0 0 1 .902-.902h9.918V6.99H1.274a.902.902 0 0 1-.902-.901Z" />
      <path
        fill={currentColor}
        d="m7.585.679 5.41 5.41-5.41 5.41a.901.901 0 0 1-1.275 0l-.077-.078a.902.902 0 0 1 0-1.275L10.29 6.09 6.233 2.03a.902.902 0 0 1 0-1.275L6.31.68a.902.902 0 0 1 1.275 0Z"
      />
    </svg>
  )
}
